import React, { useEffect, useRef, useState } from "react";
import "./AnimatedHeader.css";
import boyImage from "../assets/boy.png"; // Importa la imagen del niño
import backgroundImage from "../assets/empty-room.jpg";

const AnimatedHeader = () => {
  const contentRef = useRef(null);
  const [poem, setPoem] = useState("");

  useEffect(() => {
    const adjustContentSize = () => {
      if (!contentRef.current) return;
      const viewportWidth = window.innerWidth;
      const baseWidth = 1000;
      const scaleFactor = viewportWidth < baseWidth ? (viewportWidth / baseWidth) * 0.9 : 1.2;
      contentRef.current.style.transform = `scale(${scaleFactor})`;
    };

    window.addEventListener("resize", adjustContentSize);
    adjustContentSize(); // Ajustar al cargar

    setTimeout(() => {
      setPoem(`
        <p class="pHeader">
        Si puedes <span class="spanHeader">levantarte</span> cada mañana con la determinación  
        de dar un paso más hacia tu <span class="spanHeader">sueño</span>,  
        Si puedes <span class="spanHeader">seguir adelante</span> cuando el cansancio y la duda  
        intentan detenerte,      
        Si puedes <span class="spanHeader">soñar</span> en grande, pero no quedarte  
        atrapado en los sueños sin acción,     
        Entonces, sin importar lo que digan los demás,  
        sin importar cuántas veces caigas,  
        Tuya es la <span class="spanHeader">vida</span> y todo lo que hay en ella,  
        Y—lo que es más—¡serás un <span class="spanHeader">triunfador</span> de tu propio destino!  
        </p>
      `);
    }, 250); // Espera para evitar que se ejecute antes de montarse el DOM

    return () => {
      window.removeEventListener("resize", adjustContentSize);
    };
  }, []);

  return (
    <div className="body">
      <div className="containerH">
        <div ref={contentRef} className="contentH">
          <div className="containerH-full">
            <div className="animated hue"></div>
            <img className="backgroundImage" src={backgroundImage} alt="Background" />
            <img className="boyImage" src={boyImage} alt="Boy" />
            <div className="containerH">
              <div className="cubeH">
                <div className="faceH top"></div>
                <div className="faceH bottom"></div>
                <div className="faceH left text" dangerouslySetInnerHTML={{ __html: poem }}></div>
                <div className="faceH right text" dangerouslySetInnerHTML={{ __html: poem }}></div>
                <div className="faceH front"></div>
                <div className="faceH backH text" dangerouslySetInnerHTML={{ __html: poem }}></div>
              </div>
            </div>
            <div className="containerH-reflect">
              <div className="cubeH">
                <div className="faceH top"></div>
                <div className="faceH bottom"></div>
                <div className="faceH left text" dangerouslySetInnerHTML={{ __html: poem }}></div>
                <div className="faceH right text" dangerouslySetInnerHTML={{ __html: poem }}></div>
                <div className="faceH front"></div>
                <div className="faceH backH text" dangerouslySetInnerHTML={{ __html: poem }}></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimatedHeader;
